<template>
  <div class="flex-grow-1 d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="receipts"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
      :date="date"
      :externalFilters="external"
    ></filtered-data>

    <div class="container-fluid d-flex align-items-center">
      <h1 class="page-heading mr-auto">Чеки</h1>
      <div class="input-group mr-1" style="max-width: 15em">
        <div class="input-group-prepend">
          <span class="input-group-text">ИНН</span>
        </div>
        <input type="number" class="form-control" v-model="inn" min="0">
      </div>
      <div class="input-group mr-1" style="max-width: 27em">
        <div class="input-group-prepend">
          <span class="input-group-text">Номер фискального накопителя</span>
        </div>
        <input type="number" class="form-control"  v-model="fsNumber" min="0">
      </div>
      <button class="btn btn-sm btn-outline-primary mr-3" @click="save">Применить</button>
      <el-date-picker
        class="mr-2"
        v-model="date"
        type="datetimerange"
        :clearable="false"
        value-format="yyyy-MM-ddTHH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        range-separator="–"
        :picker-options="pickerOptions"
        size="small"
      />
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @filter-change="filterChange"
        @sort-change="sortChange"
      >
        <el-table-column type="expand">
          <template slot-scope="{row}">
            <receipt-details :receipt="row"></receipt-details>
          </template>
        </el-table-column>
        <table-column-serial-number sortable="custom" machine-prop="machine"/>
        <!--<el-table-column prop="id" label="ID чека" width="300" align="center">-->
          <!--<small slot-scope="{row}" class="text-monospace">{{ row.id }}</small>-->
        <!--</el-table-column>-->
        <el-table-column prop="status"
                         label="Статус"
                         :filters="data.allow_statuses"
                         filter-placement="bottom-start"
                         column-key="status"
                         width="120"
                         align="center"/>
        <el-table-column prop="check_data.payment_type"
                         label="Тип оплаты"
                         :filters="data.payment.types"
                         filter-placement="bottom-start"
                         column-key="payment_type"
                         width="120"
                         align="left"/>
        <el-table-column prop="kkt"
                         label="ККТ"
                         :filters="data.kkt"
                         filter-placement="bottom-start"
                         column-key="kkt"
                         width="120"
                         align="left"/>
        <el-table-column sortable="custom" prop="product_name" label="Продукт"/>
        <table-column-number sortable="custom" prop="price" label="Цена, руб." align="center"/>
        <table-column-date prop="created_at" label="Время" align="right"/>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep.js'
  import moment from 'moment'

  export default {
    metaInfo: {title: 'Чеки'},
    data () {
      return {
        filtersValue: {
          ...(this.$route.query.missed ? {missed: this.$route.query.missed} : {missed: false}),
          ...(this.$route.query.machine_id ? {machine_id: this.$route.query.machine_id} : {}),
        },
        data: {},
        loading: false,
        hasMore: true,
        sort: null,
        date: [
          moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
          moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        ],
        pickerOptions: {
          firstDayOfWeek: 1,
        },
        inn: null,
        fsNumber: null,
        external: null,
      }
    },
    computed: {
      statusFilters () {
        return 'allow_statuses' in this.data ? cloneDeep(this.data.allow_statuses) : []
      },
      externalData () {
        let data = {}
        if (this.inn) data.inn = this.inn
        if (this.fsNumber) data.fs_number = this.fsNumber
        return data
      },
    },
    methods: {
      filterChange (filter) {
        this.filtersValue = Object.assign({}, this.filtersValue, filter)
      },
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = `${sort.prop}:${order}`
        } else {
          this.sort = null
        }
      },
      save () {
        this.external = this.externalData
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .vjs__tree {
    font-family: $font-family-monospace !important;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/receipts/index.vue